import authImg from '@/assets/images/auth-bg.png';
import { MODAL_KEYS } from '@/common/constants';
import { LogoIconDark } from '@/common/icons/LogoIconDark';
import { InputControl } from '@/components/controls/input-control';
import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form';
import { useAuth } from '@/features/auth/hooks';
import { useModal } from '@/hooks/useModal';
import { cn } from '@/lib/utils';
import { Loader2Icon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CropSelection } from './CropSelection';

export const Auth: FC = () => {
  const { t } = useTranslation();
  const { isOpen } = useModal(MODAL_KEYS.CROP_SELECTION);
  const { form, handleForm, isLoading, sessionData } = useAuth();

  const { control } = form;

  const year = new Date().getFullYear();

  return (
    <div className="h-screen w-full flex items-stretch bg-white overflow-hidden">
      <div className={cn('w-1/2 h-full flex-v-center-between py-8')}>
        <LogoIconDark />
        <Form {...form}>
          <form onSubmit={handleForm} className={cn('w-[340px] space-y-5')}>
            <div className="mb-8 flex-v-center space-y-2 ">
              <p className="text-2xl text-black font-medium text-center">
                {t('sign.in')}
              </p>
              <p className="text-sm text-gray-700 text-center">
                {t('auth.welcome')}
              </p>
            </div>
            <div className="space-y-4">
              <InputControl
                control={control as any}
                name="username"
                label={t('login')}
                placeholder={t('enter.login')}
                labelClass={'text-xs mb-1'}
              />
              <InputControl
                control={control as any}
                name="password"
                label={t('password')}
                placeholder={t('enter.password')}
                labelClass={'text-xs mb-1'}
                type={'password'}
              />
            </div>
            <Button
              type="submit"
              variant="link"
              className={cn('w-full')}
              disabled={isLoading}
            >
              {isLoading && <Loader2Icon className="animate-spin" />}
              {t('log.in')}
            </Button>
          </form>
        </Form>
        <p className="text-gray-700 text-sm">© {year} AgroTarozi</p>
      </div>
      <div className={cn('w-1/2 h-screen')}>
        <img
          src={authImg}
          alt="auth image"
          className={cn('w-full h-screen object-cover')}
        />
      </div>
      {isOpen && <CropSelection sessionData={sessionData} />}
    </div>
  );
};
